import { useEffect } from "react";

export default function useOnMounted(
  onMountFunction: () => void,
  onUnmountFunction?: () => void,
) {

  useEffect(() => {
    if (typeof window === "undefined") { return; }
    onMountFunction();

    return () => {
      if (onUnmountFunction) {
        onUnmountFunction();
      }
    };
  }, []);
}
